import React, { useState, useEffect } from "react";
import "./App.css";

const MaterialCostInput = ({ material, cost, onCostChange }) => {
  const handleChange = (e) => {
    const newValue = e.target.value === "" ? "" : parseFloat(e.target.value);
    onCostChange(material, isNaN(newValue) ? 0 : newValue);
  };

  return (
    <div className="material-cost-container">
      <label className="material-cost-label">{material}: </label>
      <input
        className="material-cost-input"
        type="number"
        value={cost !== undefined ? cost.toString() : ""}
        onChange={handleChange}
        placeholder="Cost per Unit"
      />
    </div>
  );
};

const ItemSelection = ({
  selectedProfession,
  setSelectedProfession,
  selectedSubdivision,
  setSelectedSubdivision,
  selectedItem,
  setSelectedItem,
  materialCosts,
  setMaterialCosts,
  expBonusPercentage,
  salePrice,
  setSalePrice,
  setExpBonusPercentage,
  professions,
  setResult,
}) => {
  const handleProfessionChange = (e) => {
    const newProfession = e.target.value;
    setSelectedProfession(newProfession);
    setSelectedSubdivision("");
    setSelectedItem("");
    setMaterialCosts({});
    setResult(null);
  };

  const handleCostChange = (material, value) => {
    setMaterialCosts((prev) => {
      if (prev[material] === value) return prev;
      return { ...prev, [material]: value };
    });
  };

  return (
    <>
      <select value={selectedProfession} onChange={handleProfessionChange}>
        <option value="">Select a profession</option>
        {Object.keys(professions).map((profession) => (
          <option key={profession} value={profession}>
            {profession}
          </option>
        ))}
      </select>

      {selectedProfession && professions[selectedProfession] && (
        <select
          value={selectedSubdivision}
          onChange={(e) => setSelectedSubdivision(e.target.value)}
        >
          <option value="">Select a subdivision</option>
          {Object.keys(professions[selectedProfession]).map((subdivision) => (
            <option key={subdivision} value={subdivision}>
              {subdivision}
            </option>
          ))}
        </select>
      )}

      {selectedSubdivision &&
        professions[selectedProfession] &&
        professions[selectedProfession][selectedSubdivision] && (
          <select
            value={selectedItem}
            onChange={(e) => setSelectedItem(e.target.value)}
          >
            <option value="">Select an item</option>
            {Object.keys(
              professions[selectedProfession][selectedSubdivision]
            ).map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        )}

      {selectedItem &&
        professions[selectedProfession] &&
        professions[selectedProfession][selectedSubdivision] &&
        professions[selectedProfession][selectedSubdivision][selectedItem] &&
        Object.entries(
          professions[selectedProfession][selectedSubdivision][selectedItem]
            .Materials
        ).map(([material]) => (
          <MaterialCostInput
            key={material}
            material={material}
            cost={materialCosts[material]}
            onCostChange={handleCostChange}
          />
        ))}

      <div className="sale-price-container">
        <label className="sale-price-label">
          Selling Price for {selectedItem}
        </label>
        <input
          className="sale-price-input"
          type="number"
          value={salePrice || ""}
          onChange={(e) => setSalePrice(parseFloat(e.target.value) || 0)}
          placeholder="Selling Price"
        />
      </div>
      <div className="exp-bonus-container">
        <label className="exp-bonus-label">
          EXP Bonus for {selectedProfession} (%):{" "}
        </label>
        <input
          className="exp-bonus-input"
          type="number"
          value={expBonusPercentage || ""}
          onChange={(e) =>
            setExpBonusPercentage(parseFloat(e.target.value) || 0)
          }
          placeholder="EXP Bonus Percentage"
        />
      </div>
    </>
  );
};
const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button onClick={onClose} className="modal-close-button">
          Close
        </button>
        {children}
      </div>
    </div>
  );
};

function App() {
  const [professions, setProfessions] = useState({});
  const [selectedProfession1, setSelectedProfession1] = useState("");
  const [selectedSubdivision1, setSelectedSubdivision1] = useState("");
  const [selectedItem1, setSelectedItem1] = useState("");
  const [materialCosts1, setMaterialCosts1] = useState({});
  const [salePrice1, setSalePrice1] = useState({});
  const [salePrice2, setSalePrice2] = useState({});
  const [expBonusPercentage1, setExpBonusPercentage1] = useState(0);
  const [expBonusPercentage2, setExpBonusPercentage2] = useState(0);
  const [selectedProfession2, setSelectedProfession2] = useState("");
  const [selectedSubdivision2, setSelectedSubdivision2] = useState("");
  const [selectedItem2, setSelectedItem2] = useState("");
  const [materialCosts2, setMaterialCosts2] = useState({});

  const [result, setResult] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/list-professions`, {
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setProfessions(data);
      })
      .catch((error) => {
        console.error("Erro ao buscar profissões:", error);
      });
  }, []);

  const allFieldsFilled = () => {
    return (
      selectedProfession1 &&
      selectedSubdivision1 &&
      selectedItem1 &&
      salePrice1 &&
      selectedProfession2 &&
      selectedSubdivision2 &&
      selectedItem2 &&
      salePrice2 &&
      Object.values(materialCosts1).every((value) => value > 0) &&
      Object.values(materialCosts2).every((value) => value > 0)
    );
  };

  const handleCompare = () => {
    if (!allFieldsFilled()) {
      alert("Please fill in all required fields for both items.");
      return;
    }
    const dataToSend = [
      {
        profession: selectedProfession1,
        subdivision: selectedSubdivision1,
        item: selectedItem1,
        materialCosts: materialCosts1,
        salePrice: salePrice1,
        expBonusPercentage: expBonusPercentage1,
      },
      {
        profession: selectedProfession2,
        subdivision: selectedSubdivision2,
        item: selectedItem2,
        materialCosts: materialCosts2,
        salePrice: salePrice2,
        expBonusPercentage: expBonusPercentage2,
      },
    ];

    fetch(`${process.env.REACT_APP_API_URL}/compare`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_API_KEY,
      },
      body: JSON.stringify(dataToSend),
    })
      .then((response) => response.json())
      .then((data) => {
        setResult(data);
        setIsModalOpen(true);
      })
      .catch((error) => console.error("Erro na comparação:", error));
  };
  return (
    <div className="App">
      <header className="App-header">
        <h1>Craft Calculator</h1>
        <div className="comparison-section">
          <div className="item-selection">
            <h2>Item 1</h2>
            <ItemSelection
              selectedProfession={selectedProfession1}
              setSelectedProfession={setSelectedProfession1}
              selectedSubdivision={selectedSubdivision1}
              setSelectedSubdivision={setSelectedSubdivision1}
              selectedItem={selectedItem1}
              setSelectedItem={setSelectedItem1}
              materialCosts={materialCosts1}
              setMaterialCosts={setMaterialCosts1}
              salePrice={salePrice1}
              setSalePrice={setSalePrice1}
              expBonusPercentage={expBonusPercentage1}
              setExpBonusPercentage={setExpBonusPercentage1}
              professions={professions}
              setResult={setResult}
            />
          </div>
          <div className="item-selection">
            <h2>Item 2</h2>
            <ItemSelection
              selectedProfession={selectedProfession2}
              setSelectedProfession={setSelectedProfession2}
              selectedSubdivision={selectedSubdivision2}
              setSelectedSubdivision={setSelectedSubdivision2}
              selectedItem={selectedItem2}
              setSelectedItem={setSelectedItem2}
              materialCosts={materialCosts2}
              setMaterialCosts={setMaterialCosts2}
              salePrice={salePrice2}
              setSalePrice={setSalePrice2}
              expBonusPercentage={expBonusPercentage2}
              setExpBonusPercentage={setExpBonusPercentage2}
              professions={professions}
              setResult={setResult}
            />
          </div>
        </div>
        <button
          onClick={handleCompare}
          disabled={!allFieldsFilled()} // Botão desabilitado se nem todos os campos estiverem preenchidos
        >
          Compare
        </button>
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          {result && (
            <>
              <p className="best-item">
                Best item for experience:{" "}
                {result.betterItemForXP || "Data not available"}
              </p>
              <p className="best-item">
                Best item for profit/less loss:{" "}
                {result.betterItemForProfit || "Data not available"}
              </p>
              
              <div className="result-section">
                <div className="item-details">
                  <p>
                    Net cost per XP for {selectedItem1}:{" "}
                    {result.details &&
                    result.details[selectedItem1] &&
                    result.details[selectedItem1].netCostPerXP !== undefined
                      ? result.details[selectedItem1].netCostPerXP.toFixed(2)
                      : "Data not available"}{" "}
                    Coins
                  </p>
                  <p>
                    Total cost of {selectedItem1}:{" "}
                    {result.details &&
                    result.details[selectedItem1] &&
                    result.details[selectedItem1].totalMaterialCost !==
                      undefined
                      ? result.details[selectedItem1].totalMaterialCost.toFixed(
                          2
                        )
                      : "Data not available"}{" "}
                    Coins
                  </p>
                  <p>
                    Net profit of {selectedItem1}:{" "}
                    {result.details &&
                    result.details[selectedItem1] &&
                    result.details[selectedItem1].netProfit !== undefined
                      ? result.details[selectedItem1].netProfit.toFixed(2)
                      : "Data not available"}{" "}
                    Coins
                  </p>
                  <p>
                    Profit/loss percentage for {selectedItem1}:{" "}
                    {result.details &&
                    result.details[selectedItem1] &&
                    result.details[selectedItem1].profitPercentage !== undefined
                      ? result.details[selectedItem1].profitPercentage.toFixed(
                          2
                        )
                      : "Data not available"}
                    %
                  </p>
                </div>

                <div className="item-details">
                  <p>
                    Net cost per XP for {selectedItem2}:{" "}
                    {result.details &&
                    result.details[selectedItem2] &&
                    result.details[selectedItem2].netCostPerXP !== undefined
                      ? result.details[selectedItem2].netCostPerXP.toFixed(2)
                      : "Data not available"}{" "}
                    Coins
                  </p>
                  <p>
                    Total cost of {selectedItem2}:
                    {result.details &&
                    result.details[selectedItem2] &&
                    result.details[selectedItem2].totalMaterialCost !==
                      undefined
                      ? result.details[selectedItem2].totalMaterialCost.toFixed(
                          2
                        )
                      : "Data not available"}{" "}
                    Coins
                  </p>
                  <p>
                    Net profit of {selectedItem2}:{" "}
                    {result.details &&
                    result.details[selectedItem2] &&
                    result.details[selectedItem2].netProfit !== undefined
                      ? result.details[selectedItem2].netProfit.toFixed(2)
                      : "Data not available"}{" "}
                    Coins
                  </p>
                  <p>
                    Profit/loss percentage for {selectedItem2}:{" "}
                    {result.details &&
                    result.details[selectedItem2] &&
                    result.details[selectedItem2].profitPercentage !== undefined
                      ? result.details[selectedItem2].profitPercentage.toFixed(
                          2
                        )
                      : "Data not available"}
                    %
                  </p>
                </div>
              </div>
            </>
          )}
        </Modal>
      </header>
    </div>
  );
}

export default App;
